<script>
	export let careers = []

	function onClick(e) {
		let currentIsActive = e.target
			.closest('.testimonials-item')
			.classList.contains('active')
		let elems = document.querySelectorAll('.active')
		let careerContent = e.target
			.closest('.testimonials-item')
			.getElementsByClassName('testimonial-content')[0]
		let contentHeight = undefined
		if (careerContent) {
			contentHeight = careerContent.clientHeight
		}
		;[].forEach.call(elems, function (e) {
			//remove active class from all elements
			e.classList.remove('active')
			//reset padding
			e.style.paddingBottom = 0
			let svg = e.querySelector('svg')
			//reset svg
			if (svg) {
				svg.classList.remove('svg-transition')
			}
		})

		if (currentIsActive == false) {
			//add active class to element targeted
			//the active class will be removed from an element that is already active
			e.target.closest('.testimonials-item').classList.add('active')
			//add padding equivalent to content height
			e.target.closest('.testimonials-item').style.paddingBottom =
				contentHeight + 'px'
			let svg = e.target.closest('.testimonials-item').querySelector('svg')
			if (svg) {
				svg.classList.add('svg-transition')
			}
		}
	}
</script>

<div class="testimonials-wrap">
	{#each careers as career}
		<div class="testimonials-item">
			<div class="testimonials-inner" on:click={onClick}>
				<p class="testimonial-name">{career.name}</p>
				{#if career.title}
					<p class="testimonial-title">{career.title}</p>
				{/if}
				{#if career.hiring}
					<p class="testimonial-location">HIRING!</p>
				{/if}

				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 341.4 341.4">
					<path d="M149.4 0H192v341.4h-42.6z" class="vertical-line" />
					<path d="M0 149.4h341.4V192H0z" class="horizontal-line" />
				</svg>
			</div>
			{#if career.content}
				<div class="testimonial-content">
					{@html career.content}
				</div>
			{/if}
		</div>
	{/each}
</div>
